import React from 'react';
import { StyledGridContainer, StyledPaper } from "../styles"
import { Typography, Grid, } from '@mui/material';

function ConnectedRoadwaysDetails(props) {

  const {
    formValues }
    = props;
  const roadways = formValues.connectedRoadways;
  return (
    <Grid item xs={12} md={12}>
      <StyledPaper elevation={3}>
        {roadways && roadways.length > 0 ? (
          <div style={{ overflowX: 'auto' }}>
            <table
              style={{
                width: 'calc(100% - 32px)',
                borderCollapse: 'collapse',
                margin: '8px 16px'
              }}
              aria-label="Connected Roadways Details Table"
            >
              <thead>
                <tr style={{ textAlign: 'left' }}>
                  <th style={{ padding: '8px' }}>Roadway Name</th>
                  <th style={{ padding: '8px' }}>From Road</th>
                  <th style={{ padding: '8px' }}>To Road</th>
                  <th style={{ padding: '8px' }}>Impact Area</th>
                  <th style={{ padding: '8px' }}>Rank</th>
                </tr>
              </thead>
              <tbody>
                {roadways.map((row, index) => (
                  <tr key={index}>
                    <td style={{ padding: '8px' }}>
                      <Typography variant="body2">{row.roadName || "None"}</Typography>
                    </td>
                    <td style={{ padding: '8px' }}>
                      <Typography variant="body2">{row.fromRoad || "None"}</Typography>
                    </td>
                    <td style={{ padding: '8px' }}>
                      <Typography variant="body2">{row.toRoad || "None"}</Typography>
                    </td>
                    <td style={{ padding: '8px' }}>
                      <Typography variant="body2">{row.impactArea || "None"}</Typography>
                    </td>
                    <td style={{ padding: '8px' }}>
                      <Typography variant="body2">{row.rank || "None"}</Typography>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <Typography variant="body2" sx={{ p: 2 }}>
            No connected roadways available.
          </Typography>
        )}
      </StyledPaper>
    </Grid>

  );
}



export default ConnectedRoadwaysDetails;
